
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profil/fotografije",
      function () {
        return require("private-next-pages/profil/fotografije.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profil/fotografije"])
      });
    }
  